import { useEffect, useRef } from "react"

export const useChangeEffect = (func: () => void, deps: React.DependencyList) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            return func();
        } else {
            didMount.current = true;
        }
    }, deps);
}